import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export default class collapsableUI extends Plugin {
    init() {
        console.log( 'collapsableUI#init() got called' );
        console.log("new execute");

        const editor = this.editor;
        const t = editor.t

        editor.ui.componentFactory.add( 'divInput', locale => {

            const command = editor.commands.get( 'insertCollapsable' )

            const buttonView = new ButtonView( locale )

            buttonView.set({
                label: t( 'Insert Collapsable' ),
                withText: true,
                tooltip:true,
            });

            buttonView.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' )
            this.listenTo( buttonView, 'execute', () => editor.execute( 'insertCollapsable'));

            return buttonView
    
    })
  }
}